module.exports = "../fonts/vendor/primevue/resources/themes/lara-light-indigo/Inter-Bold.woff?93c1301bd9f486c573b3d9001c6ec0e4";